/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaginationAndOrderParam { 
    /**
     * Offset applied to the first element of the returned list.
     */
    offset?: number;
    /**
     * Number of items in returned list.
     */
    pageSize?: number;
    /**
     * If true, returned list is sorted ascending otherwise is returned descending.
     */
    isAscending?: boolean;
    /**
     * Field name that sorts the returned list.
     */
    sortby?: string;
}

